
import React from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useNavigate, useLocation } from "react-router-dom";

const QuestionManagementMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const getValue = () => {
    if (currentPath.includes("generator")) return "generator";
    if (currentPath.includes("reports")) return "reports";
    if (currentPath.includes("logs")) return "logs";
    if (currentPath.includes("subjects")) return "subjects";
    if (currentPath.includes("suggestions")) return "suggestions";
    if (currentPath.includes("email-templates")) return "email-templates";
    if (currentPath.includes("email-campaigns")) return "email-campaigns";
    return "questions";
  };

  return (
    <div className="mb-4">
      <Tabs 
        defaultValue={getValue()} 
        value={getValue()}
        className="w-full"
        onValueChange={(value) => {
          if (value === "questions") {
            navigate("/admin/questions");
          } else if (value === "logs") {
            navigate("/admin/logs");
          } else if (value === "generator") {
            navigate("/admin/generator");
          } else if (value === "reports") {
            navigate("/admin/reports");
          } else if (value === "subjects") {
            navigate("/admin/subjects");
          } else if (value === "suggestions") {
            navigate("/admin/suggestions");
          } else if (value === "email-templates") {
            navigate("/admin/email-templates");
          } else if (value === "email-campaigns") {
            navigate("/admin/email-campaigns");
          }
        }}
      >
        <TabsList className="grid w-full max-w-2xl grid-cols-8">
          <TabsTrigger value="questions">Questions</TabsTrigger>
          <TabsTrigger value="generator">Generator</TabsTrigger>
          <TabsTrigger value="reports">Reports</TabsTrigger>
          <TabsTrigger value="subjects">Subjects</TabsTrigger>
          <TabsTrigger value="suggestions">Suggestions</TabsTrigger>
          <TabsTrigger value="logs">AI Logs</TabsTrigger>
          <TabsTrigger value="email-templates">Emails</TabsTrigger>
          <TabsTrigger value="email-campaigns">Campaigns</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};

export default QuestionManagementMenu;
